var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogoDigibee24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 694.18 496.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Gradiente_sem_nome_66);}.cls-2{fill:url(#Gradiente_sem_nome_64);}.cls-3{fill:url(#Gradiente_sem_nome_61);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_66",
    x1: 222,
    y1: 291.5,
    x2: 534,
    y2: 291.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aad3ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51b58e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_64",
    x1: 362,
    y1: 139,
    x2: 534,
    y2: 139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8ae3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec6d15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_61",
    x1: 165,
    y1: 236.5,
    x2: 336,
    y2: 236.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a5d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7877b6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.5,425A12.51,12.51,0,0,1,337,412.5V226.83L229.69,182A12.5,12.5,0,0,1,239.31,159l115,48A12.51,12.51,0,0,1,362,218.5V393.62l147-62.39V194.5a12.5,12.5,0,0,1,25,0v145A12.5,12.5,0,0,1,526.38,351l-172,73A12.52,12.52,0,0,1,349.5,425Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M406.5,207a12.5,12.5,0,0,1-4.81-24l87.72-36.61L369.58,95a12.5,12.5,0,0,1,9.84-23l147,63a12.5,12.5,0,0,1-.11,23l-115,48A12.55,12.55,0,0,1,406.5,207Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M292.49,401a12.48,12.48,0,0,1-4.89-1l-115-49a12.49,12.49,0,0,1-7.6-11.5v-194A12.5,12.5,0,0,1,172.68,134l146-61A12.5,12.5,0,1,1,328.32,96L190,153.82V331.24L297.4,377a12.5,12.5,0,0,1-4.91,24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoDigibee24X24);
export default __webpack_public_path__ + "static/media/icon-logo-digibee-24x24.3facc3f80739f363a883a9cff3b1f12e.svg";
export { ForwardRef as ReactComponent };